import { adminRouteTitleHead } from '@/lib/admin-route-title'
import { useCustomPage } from '@/lib/services/custom-pages/custom-pages.query'
import { customPageRouteParamsSchema } from '@/lib/services/custom-pages/custom-pages.schema'
import { createFileRoute } from '@tanstack/react-router'
import { CustomPageDetail } from './-custom-page-detail'
import { loadCustomPageRoute } from './-loader'

export const Route = createFileRoute('/_authenticated/$orgId/website/custom-pages/$customPageId')({
  component: CustomPagePage,
  head: adminRouteTitleHead,
  params: {
    parse: (params) => customPageRouteParamsSchema.parse(params),
  },
  loader: loadCustomPageRoute,
})

function CustomPagePage() {
  const { orgId, customPageId } = Route.useParams()
  const { data: customPage } = useCustomPage(customPageId, { organizationId: orgId })

  return <CustomPageDetail key={customPage.id} customPage={customPage} />
}
